import type { BrainstormRepository, BrainstormQuery, Candidate, Narrative, BrainstormObservation } from '../repository'
import {
  blockEditorCandidates,
  chatCandidates,
  wizardCandidates,
  galleryCandidates,
  dsAxisCandidates,
  narrativeMap,
} from '../fixtures'

const FIXTURE_DISPATCH: Record<BrainstormQuery['entry'], Candidate[]> = {
  'block-editor': blockEditorCandidates,
  'chat': chatCandidates,
  'wizard': wizardCandidates,
  'gallery': galleryCandidates,
  'ds-axis': dsAxisCandidates,
}

export function createMockBrainstormProvider(): BrainstormRepository {
  return {
    async findCandidates(query: BrainstormQuery): Promise<Candidate[]> {
      return FIXTURE_DISPATCH[query.entry] ?? []
    },
    async getNarrative(exampleId: string): Promise<Narrative | null> {
      return narrativeMap[exampleId] ?? null
    },
    async recordObservation(obs: BrainstormObservation): Promise<void> {
      console.debug('brainstorm-observation', obs)
    },
  }
}
